import { defineStore } from "pinia";
// import userData from '../views/GoogleLogin.vue'

export const useUserStore = defineStore("user", {
    state: () => ({
        user: null,
    }),

    actions: {
        async fetchUser() {

            return this.user
        },
        async setUser(user) {
            return this.user = user
        },
        async signUp(email, password) {
            const res = await fetch("https://localhost:3000/register", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email, password }),
            });
            const user = await res.json()
            this.user = user;
        },
        async signIn(email, password) {
            const res = await fetch("https://localhost:3000/register", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email, password }),
            });
            const user = await res.json();
            this.user = user;
        },
    },
});